module.exports = __webpack_public_path__ + "img/icon_csv_white.63a6f587.svg";